export const ImagesEndpoints = {
    upload: () => '/images',
};
